export const getButtonLabel = ({ id, selectedId = 'none', t, label }) => {
  if (id === selectedId || selectedId === 'none') {
    return t(label)
  }

  return `vs ${t(label)}`
}

export const getButtonClasses = ({ id, selectedId }) => {
  return selectedId === id
    ? 'button-container-item dash-btn-active'
    : 'button-container-item dash-btn-inactive'
}
